import { render, staticRenderFns } from "./SolutionBox.vue?vue&type=template&id=1bd4a072&scoped=true&"
import script from "./SolutionBox.vue?vue&type=script&lang=js&"
export * from "./SolutionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4a072",
  null
  
)

export default component.exports